import React from "react";
import {
  MapPin,
  Phone,
  Mail,
  Facebook,
  Instagram,
  Youtube,
} from "lucide-react";
import Logo from "../assests/logo.png";
import Bimg from "../assests/Footer.png";

const Footer = () => {
  const handleMapClick = () => {
    window.open("https://maps.app.goo.gl/RjnqWj4LbqyMHX6SA");
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:hello@thegreathoneyco.com";
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+918639542319";
  };

  return (
    <footer
      className="text-black bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${Bimg})` }}
    >
      <div className="">
        <div className="max-w-7xl mx-auto px-6 py-4">
    
          {/* Grid Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
            {/* Contact Info */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold uppercase tracking-wide">Contact Us</h3>
              <button
                onClick={handleMapClick}
                className="flex items-start gap-2 hover:text-orange-600 mx-auto md:mx-0 text-sm"
              >
                <MapPin className="h-5 w-5 mt-1" />
                <span>7-1-215/C/3, D.K Road, Hyderabad, India - 500038</span>
              </button>
              <button
                onClick={handlePhoneClick}
                className="flex items-center gap-2 hover:text-orange-600 mx-auto md:mx-0 text-sm"
              >
                <Phone className="h-5 w-5" />
                <span>+91 8639542319</span>
              </button>
              <button
                onClick={handleEmailClick}
                className="flex items-center gap-2 hover:text-orange-600 mx-auto md:mx-0 text-sm"
              >
                <Mail className="h-5 w-5" />
                <span>hello@thegreathoneyco.com</span>
              </button>
            </div>

            {/* Spacer / Logo Area */}
            <div className="hidden md:block" />

            {/* Quick Links */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold uppercase tracking-wide">Quick Links</h3>
              <a href="/privacy-policy" className="hover:text-orange-600 block text-sm">
                Privacy Policy
              </a>
              <a href="/shipping-policy" className="hover:text-orange-600 block text-sm">
                Shipping Policy
              </a>
              <a href="/rar-policy" className="hover:text-orange-600 block text-sm">
                Refund and Return Policy
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="mt-1 flex justify-center gap-6">
            <a
              href="https://www.facebook.com/TheGreatHoneyCompany/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook className="h-6 w-6 hover:text-orange-600" />
            </a>
            <a
              href="https://www.instagram.com/thegreathoneyco/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram className="h-6 w-6 hover:text-orange-600" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCDDcu0pPLSl-9INnR4gEOxQ/featured"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <Youtube className="h-6 w-6 hover:text-orange-600" />
            </a>
          </div>

          {/* Bottom Line */}
          <div className="mt-2 border-t pt-2 text-center text-sm text-gray-700">
            © {new Date().getFullYear()}{" "}
            <a href="/" className="hover:text-orange-600 font-medium">
              The Great Honey Company
            </a>
            . All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
